// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NavbarLink_control__PJU5W {
  display: block;
  border-radius: var(--mantine-radius-md);
  width: calc(100% - var(--mantine-spacing-md) * 2);
  margin: calc(var(--mantine-spacing-sm) + 0.25rem) var(--mantine-spacing-md);
  padding: 10px var(--mantine-spacing-md);
  font-size: 0.875rem;
  border: 1px solid transparent;
}
.NavbarLink_control__PJU5W:hover:not(.NavbarLink_controlActive__\\+yzh2):not(.NavbarLink_controlOpenActive__969f4) {
  background-color: light-dark(var(--mantine-color-gray-0), var(--mantine-color-dark-7));
  color: light-dark(var(--mantine-color-black), var(--mantine-color-dark-0));
}
.NavbarLink_control__PJU5W.NavbarLink_controlActive__\\+yzh2 {
  background-color: var(--hover-bg);
  font-weight: 500;
  border-color: var(--nl-color);
}
.NavbarLink_control__PJU5W.NavbarLink_controlOpenActive__969f4 {
  background-color: light-dark(var(--mantine-color-gray-0), var(--mantine-color-dark-7));
}

.NavbarLink_link__jjz6y {
  font-weight: 500;
  display: block;
  text-decoration: none;
  border-radius: 0 var(--mantine-radius-md) var(--mantine-radius-md) 0;
  padding: var(--mantine-spacing-xs) var(--mantine-spacing-md);
  padding-left: calc(var(--mantine-spacing-md) + 0.34rem);
  font-size: 0.875rem;
  color: light-dark(var(--mantine-color-gray-7), var(--mantine-color-dark-0));
}
.NavbarLink_link__jjz6y:hover:not(.NavbarLink_controlActive__\\+yzh2):not(.NavbarLink_controlOpenActive__969f4) {
  background-color: light-dark(var(--mantine-color-gray-0), var(--mantine-color-dark-7));
  color: light-dark(var(--mantine-color-black), var(--mantine-color-dark-0));
}

.NavbarLink_chevron__43G4l {
  transition: transform 200ms ease;
}

.NavbarLink_items__EH4Cn {
  margin: 0 var(--mantine-spacing-md) 0 2.6rem;
  border-left: 1px solid light-dark(var(--mantine-color-gray-3), var(--mantine-color-dark-4));
}

.NavbarLink_linkIcon__EoLEp {
  margin-right: var(--mantine-spacing-sm);
  color: light-dark(var(--mantine-color-gray-6), var(--mantine-color-dark-2));
}`, "",{"version":3,"sources":["webpack://./src/layouts/appLayout/sideNav/NavbarLink.module.scss"],"names":[],"mappings":"AAeA;EACE,cAAA;EACA,uCAAA;EACA,iDAAA;EACA,2EAAA;EACA,uCAAA;EACA,mBAAA;EACA,6BAAA;AAdF;AANI;EACE,sFAAA;EAIA,0EAAA;AAKN;AAcE;EACE,iCAAA;EACA,gBAAA;EACA,6BAAA;AAZJ;AAeE;EACE,sFAAA;AAbJ;;AAoBA;EACE,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,oEAAA;EACA,4DAAA;EACA,uDAAA;EACA,mBAAA;EACA,2EAAA;AAjBF;AA7BI;EACE,sFAAA;EAIA,0EAAA;AA4BN;;AAkBA;EACE,gCAAA;AAfF;;AAkBA;EACE,4CAAA;EACA,2FAAA;AAfF;;AAmBA;EACE,uCAAA;EACA,2EAAA;AAhBF","sourcesContent":["@mixin hover {\n  &:hover {\n    &:not(.controlActive):not(.controlOpenActive) {\n      background-color: light-dark(\n        var(--mantine-color-gray-0),\n        var(--mantine-color-dark-7)\n      );\n      color: light-dark(\n        var(--mantine-color-black),\n        var(--mantine-color-dark-0)\n      );\n    }\n  }\n}\n\n.control {\n  display: block;\n  border-radius: var(--mantine-radius-md);\n  width: calc(100% - var(--mantine-spacing-md) * 2);\n  margin: calc(var(--mantine-spacing-sm) + 0.25rem) var(--mantine-spacing-md);\n  padding: 10px var(--mantine-spacing-md);\n  font-size: 0.875rem;\n  border: 1px solid transparent;\n\n  @include hover;\n\n  &.controlActive {\n    background-color: var(--hover-bg);\n    font-weight: 500;\n    border-color: var(--nl-color);\n  }\n\n  &.controlOpenActive {\n    background-color: light-dark(\n      var(--mantine-color-gray-0),\n      var(--mantine-color-dark-7)\n    );\n  }\n}\n\n.link {\n  font-weight: 500;\n  display: block;\n  text-decoration: none;\n  border-radius: 0 var(--mantine-radius-md) var(--mantine-radius-md) 0;\n  padding: var(--mantine-spacing-xs) var(--mantine-spacing-md);\n  padding-left: calc(var(--mantine-spacing-md) + 0.34rem);\n  font-size: 0.875rem;\n  color: light-dark(var(--mantine-color-gray-7), var(--mantine-color-dark-0));\n\n  @include hover;\n}\n\n.chevron {\n  transition: transform 200ms ease;\n}\n\n.items {\n  margin: 0 var(--mantine-spacing-md) 0 2.6rem;\n  border-left: 1px solid\n    light-dark(var(--mantine-color-gray-3), var(--mantine-color-dark-4));\n}\n\n.linkIcon {\n  margin-right: var(--mantine-spacing-sm);\n  color: light-dark(var(--mantine-color-gray-6), var(--mantine-color-dark-2));\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"control": `NavbarLink_control__PJU5W`,
	"controlActive": `NavbarLink_controlActive__+yzh2`,
	"controlOpenActive": `NavbarLink_controlOpenActive__969f4`,
	"link": `NavbarLink_link__jjz6y`,
	"chevron": `NavbarLink_chevron__43G4l`,
	"items": `NavbarLink_items__EH4Cn`,
	"linkIcon": `NavbarLink_linkIcon__EoLEp`
};
export default ___CSS_LOADER_EXPORT___;
